import { render, staticRenderFns } from "./choiceInspectionStandard.vue?vue&type=template&id=17704e7f&scoped=true&"
import script from "./choiceInspectionStandard.vue?vue&type=script&lang=js&"
export * from "./choiceInspectionStandard.vue?vue&type=script&lang=js&"
import style0 from "./choiceInspectionStandard.vue?vue&type=style&index=0&id=17704e7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17704e7f",
  null
  
)

export default component.exports